import React from "react";
import { ASSETS, TRACK_RECORD } from "@/data/content";
import { Reveal } from "./Reveal";

const TrackRecord = () => {
  return (
    <section id="track-record" className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <Reveal>
          <p className="text-sm font-medium tracking-widest text-neutral-400 mb-3">
            TRACK RECORD
          </p>
          <h2 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight max-w-2xl mb-12">
            Embedded in the defining moments of the sound.
          </h2>
        </Reveal>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 auto-rows-[minmax(0,1fr)]">
          <Reveal className="md:col-span-2 md:row-span-2">
            <div className="afr-grain relative h-full min-h-[320px] overflow-hidden rounded-3xl border border-gray-200 shadow-sm">
              <img
                src={ASSETS.studio}
                alt="Master A Flat in the studio with AKA"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 text-white">
                <p className="text-xs uppercase tracking-widest opacity-80 mb-2">
                  Executive Production
                </p>
                <p className="font-heading text-2xl sm:text-3xl font-semibold tracking-tight max-w-md">
                  Touch My Blood, a double-platinum masterpiece with AKA.
                </p>
              </div>
            </div>
          </Reveal>

          {TRACK_RECORD.slice(1, 3).map((t, i) => (
            <Reveal key={t.k} delay={i * 0.08}>
              <div className="h-full rounded-3xl border border-gray-200 bg-white p-7 transition-shadow duration-500 hover:shadow-lg">
                <div className="h-2 w-2 rounded-full bg-playing mb-5" />
                <h3 className="font-heading text-lg font-semibold tracking-tight mb-3">
                  {t.k}
                </h3>
                <p className="text-sm text-neutral-600 leading-relaxed">{t.v}</p>
              </div>
            </Reveal>
          ))}

          <Reveal className="md:col-span-1">
            <div className="h-full rounded-3xl border border-gray-200 bg-black p-7 text-white transition-shadow duration-500">
              <div className="h-2 w-2 rounded-full bg-playing mb-5" />
              <h3 className="font-heading text-lg font-semibold tracking-tight mb-3">
                {TRACK_RECORD[0].k}
              </h3>
              <p className="text-sm text-neutral-300 leading-relaxed">
                {TRACK_RECORD[0].v}
              </p>
            </div>
          </Reveal>

          <Reveal className="md:col-span-2">
            <div className="h-full rounded-3xl border border-gray-200 bg-neutral-50 p-7">
              <div className="h-2 w-2 rounded-full bg-playing mb-5" />
              <h3 className="font-heading text-lg font-semibold tracking-tight mb-3">
                {TRACK_RECORD[3].k}
              </h3>
              <p className="text-sm text-neutral-600 leading-relaxed max-w-2xl">
                {TRACK_RECORD[3].v}
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default TrackRecord;
